import { render } from "./Coin_Component.vue?vue&type=template&id=a5f18a6a"
import script from "./Coin_Component.vue?vue&type=script&lang=js"
export * from "./Coin_Component.vue?vue&type=script&lang=js"

import "./Coin_Component.vue?vue&type=style&index=0&id=a5f18a6a&lang=css"
script.render = render

export default script